import unsignedFetch from './util/unsignedFetch.js';

export default body =>
  unsignedFetch('requestPasswordReset', `${__API_BASE__}/open/users/requestPasswordReset`, 'POST', body);
